import type { PaymentStatus } from '../types/user.types';

export type DisplayStatus = 'Paid' | 'Unpaid' | 'Started' | 'Expired' | 'Refunded' | 'Unknown';

export const mapApiStatus = (status: PaymentStatus | undefined | null): DisplayStatus => {
  switch (status) {
    case 'completed':
      return 'Paid';
    case 'unpaid':
      return 'Unpaid';
    case 'started':
      return 'Started';
    case 'expired':
      return 'Expired';
    case 'refunded':
      return 'Refunded';
    default:
      return 'Unknown';
  }
};

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);
};

export const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) {
    return 'N/A';
  }
  try {
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return 'Ungültiges Datum';
    }

    return date.toLocaleDateString('de-DE', options);
  } catch (error) {
    return 'Ungültiges Datum';
  }
};

export const formatTime = (isoString: string): string => {
  try {
    return new Date(isoString).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
  } catch (e) {
    console.error('Error formatting time:', e);

    return 'Ungültige Zeit';
  }
};
